// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ant-select.ant-select-open[data-v-07daa267] .ant-select-arrow-icon svg {\n  -webkit-transform: none;\n          transform: none;\n}\n.home-ant-select.home-ant-select-open[data-v-07daa267] .home-ant-select-arrow-icon svg {\n  -webkit-transform: none;\n          transform: none;\n}\n[data-v-07daa267] .ant-select-selection-selected-value {\n  max-width: 44px;\n}\n[data-v-07daa267] .home-ant-select-selection-selected-value {\n  max-width: 44px;\n}\n", ""]);
// Exports
module.exports = exports;
